import { sidebarQueryKeys } from '@features/sidebar/api/queryKeys'
import { useQuery } from '@tanstack/react-query'
import { getTableOrganization } from '../api/tableOrganization.api'

/**
 * Fetches the current user's folder organization for tables.
 * Returns `{ tree: { folders: [] }, updated_at: null }` on first load.
 */
export function useTableOrganization() {
  return useQuery({
    queryKey: sidebarQueryKeys.tableOrganization,
    queryFn: getTableOrganization,
    staleTime: 1000 * 60 * 5, // 5 min — rarely changes
  })
}
